import React from "react";
import { Box, Typography, Container, Link, Grid } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";

function Contact({ parentToChild }: { parentToChild?: { mode: string } }) {
  const mode = parentToChild?.mode || 'dark';

  const contactInfo = [
    {
      icon: <EmailIcon />,
      label: "Email",
      value: "dfrrokaj1@outlook.com",
      link: "mailto:dfrrokaj1@outlook.com"
    },
    {
      icon: <WhatsAppIcon />,
      label: "WhatsApp",
      value: "+355 682 282 262",
      link: "https://wa.me/355682282262"
    },
    {
      icon: <LocationOnIcon />,
      label: "Location",
      value: "Tirana, Albania",
      link: null
    }
  ];

  const socialLinks = [
    {
      icon: <LinkedInIcon />,
      label: "LinkedIn",
      link: "https://www.linkedin.com/in/danielfrrokaj/"
    },
    {
      icon: <GitHubIcon />,
      label: "GitHub",
      link: "https://github.com/danielfrrokaj"
    }
  ];

  return (
    <Box 
      id="contact"
      className="items-container"
      sx={{
        padding: { xs: '2rem 1rem', md: '4rem 2rem' },
        backgroundColor: mode === 'dark' ? '#0a0d12' : '#f8f9fa',
        borderRadius: '16px',
        margin: { xs: '1rem', md: '2rem' },
      }}
    >
      <Container maxWidth="md">
        <Typography 
          variant="h2" 
          component="h2" 
          align="center"
          sx={{ 
            mb: 4,
            fontWeight: 700,
            color: mode === 'dark' ? 'white' : '#0d1116',
          }}
        >
          Let's Talk
        </Typography>

        <Typography 
          variant="body1" 
          component="p" 
          align="center"
          sx={{ 
            mb: 4,
            color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.9)',
          }}
        >
          Feel free to reach out for collaboration opportunities or just to say hello!
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={6}>
            <Typography 
              variant="h5" 
              component="h3" 
              sx={{ 
                mb: 3,
                fontWeight: 600,
                color: mode === 'dark' ? 'white' : '#0d1116',
              }}
            >
              Contact Information
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {contactInfo.map((contact, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Box 
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      backgroundColor: mode === 'dark' ? 'rgba(80, 0, 202, 0.2)' : 'rgba(80, 0, 202, 0.1)',
                      color: mode === 'dark' ? 'white' : '#0d1116',
                      borderRadius: '50%',
                      width: 40,
                      height: 40,
                    }}
                  >
                    {contact.icon}
                  </Box>
                  <Box>
                    <Typography 
                      variant="subtitle2" 
                      component="div"
                      sx={{ color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)' }}
                    >
                      {contact.label}
                    </Typography>
                    {contact.link ? (
                      <Link 
                        href={contact.link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        sx={{ 
                          color: mode === 'dark' ? 'white' : '#0d1116',
                          textDecoration: 'none',
                          '&:hover': { color: '#5000ca' }
                        }}
                      >
                        {contact.value}
                      </Link>
                    ) : (
                      <Typography 
                        variant="body1" 
                        component="div"
                        sx={{ color: mode === 'dark' ? 'white' : '#0d1116' }}
                      >
                        {contact.value}
                      </Typography>
                    )}
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography 
              variant="h5" 
              component="h3" 
              sx={{ 
                mb: 3,
                fontWeight: 600,
                color: mode === 'dark' ? 'white' : '#0d1116',
              }}
            >
              Connect With Me
            </Typography>
            
            <Box sx={{ display: 'flex', gap: 2 }}>
              {socialLinks.map((social, index) => (
                <Link 
                  key={index}
                  href={social.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1,
                    padding: 2,
                    borderRadius: '8px',
                    backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none',
                    '&:hover': { 
                      backgroundColor: mode === 'dark' ? 'rgba(80, 0, 202, 0.2)' : 'rgba(80, 0, 202, 0.1)',
                      transform: 'translateY(-5px)'
                    }
                  }}
                >
                  <Box 
                    sx={{ 
                      fontSize: '2rem',
                      color: mode === 'dark' ? 'white' : '#0d1116',
                    }}
                  >
                    {social.icon}
                  </Box>
                  <Typography 
                    variant="body2" 
                    component="div"
                    sx={{ color: mode === 'dark' ? 'white' : '#0d1116' }}
                  >
                    {social.label}
                  </Typography>
                </Link>
              ))}
            </Box>

            <Typography 
              variant="body2" 
              component="p" 
              align="center"
              sx={{ 
                mt: 4,
                color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
              }}
            >
              Looking forward to hearing from you!
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Contact;